// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu {
  position: relative;
}

  .dropdown-menu__opener--showing {
      color: #206dd2;
      outline: 0;
    }

  .dropdown-menu__menu {
    display: none;
  }

  .dropdown-menu__menu--showing {
    }

  .dropdown-menu__menu--showing--left {
        right: unset;
        left: 0;
      }

  .dropdown-menu__menu--showing {
      position: absolute;
      right: 0;
      z-index: 110;
      display: block;
      width: 100%;
      min-width: 12rem;
      -webkit-user-select: none;
              user-select: none;
      background-color: #fff;
      border-top: 2px solid #206dd2;
      box-shadow: 0 2px 2px rgb(0, 0, 0, 0.3);
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
